import { getFirebaseServices } from "shared/firebase";

/** Firebase 서비스 싱글톤 반환 — 앱 전체에서 인스턴스를 한 번만 초기화 */
const useFirebaseConfig = () => getFirebaseServices();

export default useFirebaseConfig;
